module.exports = __webpack_public_path__ + "static/media/Recruitments_Welfare04.28c6a206.png";